import { useIntl } from 'react-intl';

import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import {
  ExperienceEntityType,
  NavigationKey,
  useExperienceModuleContext,
  NavigationAnnouncement,
} from 'modules/experience-core';

import { useVenueAdsFreeTrialConfig } from '../components/free-trials/useVenueAdsFreeTrialConfig';

export const useFreeTrialsNavigationAnnouncement = (): NavigationAnnouncement<'campaigns-free-trials'>[] => {
  const { formatMessage } = useIntl();

  const {
    experienceEntity: { experienceEntityObject, experienceEntityType },
  } = useExperienceModuleContext();

  const venue: Venue | null = experienceEntityType === 'venue' ? experienceEntityObject : null;

  const freeTrials = useVenueAdsFreeTrialConfig({
    venueId: venue?.id,
    merchantId: venue?.merchant,
    country: venue?.country,
    city: venue?.city,
    productLine: venue?.product_line,
    enabled: experienceEntityType === ExperienceEntityType.VENUE,
  });

  if (freeTrials.isLoading || !freeTrials.config) {
    return [];
  }

  return [
    {
      id: 'campaigns-free-trials',
      navigationKey: NavigationKey.CAMPAIGNS,
      text: formatMessage({ id: 'campaigns.ads.free-trials.onboarding-popover' }),
      tag: formatMessage(
        { id: 'campaigns.ads.free-trials.amount-tag' },
        { amount: freeTrials.config?.formattedTotalBudgetWithCurrency },
      ),
    },
  ];
};
